/*
 * 任务相关全局交互
 */
import resourceSubject from 'next/javascripts/reactivity/resource-subject';

(function($) {

  $(function() {
    // var wrapper = $(".wrapper");
    var wrapper = $('body');

    wrapper.on('click', '.check-item-form .check-item-form-quicklink', toggleTodoPopover);

    // running a todo
    wrapper.on('ajax:success', '.todo .todo-actions .run', function(e, result) {
      var todo = $(result.html),
        old = $(e.target).closest('.todo'),
        running = $.grep($('.todo.running'), function(t, i) {
          return $(t).find('.assignee').data('guid') === tower.me.guid
        });

      tower.todoSubject.next('update', {
        id: old.attr('id').split('_')[1],
        html: result.html,
      });

      if (old.hasClass('hl')) {
        todo.addClass('hl');
      }

      if (running.length) {
        running = $(running[0]);
        running.one(simple.util.transitionEnd(), showRunningTodo);
        running.find('.pause').hide()
          .end().find('.run').css('display', 'flex')
          .end().removeClass('running')
          .find('.runner').removeClass('on');
      } else {
        showRunningTodo();
      }

      function showRunningTodo() {
          var runner = $('.runner', todo).removeClass('on'),
          list = todo.closest('.todolist');

          old.replaceWith(todo);

          setTimeout(function() {
            runner.addClass('on');
          }, 10);

          tower.adjustTodo(todo);
          tower.adjustReadableDate(todo);
          tower.initPermission(todo);
        $(".workspace .page:last .page-inner").trigger("todoupdate", [old, list, todo, list]);
      }
    }).on('ajax:success', '.todo .todo-actions .pause', function(e, result) {
      var todo = $(result.html),
        old = $(e.target).closest('.todo');

      if (old.hasClass('hl')) {
        todo.addClass('hl');
      }

      tower.todoSubject.next('update', {
        id: old.attr('id').split('_')[1],
        html: result.html,
      });

      old.one(simple.util.transitionEnd(), function() {
        old.replaceWith(todo);
        tower.adjustTodo(todo);
        tower.adjustReadableDate(todo);
        tower.initPermission(todo);
      });
      $('.runner', old).removeClass('on');
    });

    // del todo
    wrapper.on('ajax:success', '.todo-actions .del', delTodoSuccess)
      .on('ajax:beforeSend', '.todo-actions .del', beforeDelTodo)
      .on('click', ".check-item a.check-item-quicklink", toggleTodoPopover)
      .on('mouseenter touchstart', "[data-request-members]", getProjectMembers );

    // complete todo or reopen
    wrapper.on('checked', '.todo .simple-checkbox', toggleComplete);
    wrapper.on('unchecked', '.todo .simple-checkbox', toggleComplete);

    // tower.adjustTodo();

    // 切换页面前关闭任务编辑框，防止返回再添加新任务时没有获取成员信息
    tower.stack.on('pageunload', function(e, $page) {
      $('.btn-cancel-todo:visible, .btn-cancel-update-todo').trigger('click');
    });
  });


  var matesRequest = null;

  function getProjectMembers(e) {
    var $page = $('.workspace .page-inner:last');
    if ($page.is('[data-not-access]')) { return }

    var projectId = $(this).data('request-members');

    if (!tower.members) {
      tower.members = {};
    }

    var memberSelect = $('.simple-select.member-select').data('select');
    if (tower.members[projectId]) {
      tower.updateMemberList(memberSelect, tower.members[projectId]);
    } else if (!tower.members[projectId] && !matesRequest) {
      matesRequest = $.ajax({
        url: "/projects/" + projectId + "/mates",
        type: "get",
        success: function(result) {
          memberSelect = $('.simple-select.member-select').data('select');
          tower.members[projectId] = result;
          tower.updateMemberList(memberSelect, tower.members[projectId]);
          matesRequest = null;
        }
      });
    }
  }

  var dueMomentPicker = null

  function toggleTodoPopover(e) {
    var link = $(this),
      numbers = '日,一,二,三,四,五,六'.split(',');
    var resourceType = link.data('resource-type');

    if (link.hasClass('disabled')) {
      return;
    }

    var popover = link.data("popover");

    if (popover) {
      popover.destroy();
    } else {
      var content = $(simple.tpl($("#tpl-todo-popover").html()));
      var dueDate = link.find(".due").data("date") || link.find(".due").data("readable-date") || null;
      var dpEl = content.find(".hidden-due-date");

      if ($('.page-inner').is('[data-template]')) {
        content.find('.select-due-date').hide();
      }

      if (dueDate) {
        dueDate = moment.tz(dueDate, tower.me.tz);
        dpEl.val(dueDate.format('YYYY-MM-DD'));
      }

      dueMomentPicker = simple.momentpicker({
        el: dpEl,
        inline: true,
        cls: 'no-border'
      });

      dueMomentPicker.on('select', function(e, params) {
        var date = params.moment.tz(tower.me.tz).endOf('day');
        var txtEl = content.find('.txt-due-date');

        txtEl.val(date.format('YYYY-MM-DD'))
          .removeClass('active error')
          .addClass('selected')
          .data('date', date)
          .nextAll('.due-date-picker')
          .hide()
          .end()
          .parent()
          .addClass('selected')
          .trigger('dateselected', [date]);

        txtEl.closest('.simple-popover').data('dirty', true);
        dueDateVal = txtEl.val();

        hidePopover();
      });

      if (dueDate) {
        var str = dueDate.readableDate({
          defaultFormat: 'YYYY-MM-DD'
        });

        content.find('.txt-due-date').val(str)
          .addClass('selected')
          .data('date', dueDate)
          .parent()
          .addClass('selected');
      }

      // 根据指派按钮在可视屏幕中的位置，决定 popover 中的 select 弹出框的位置
      var className = '';
      if ($(window).height() - link.offset().top < 250) {
        className = 'atBottom';
      }

      simple.popover({
        pointTo: link,
        content: content,
        cls: className
      });

      var memberSelect = simple.select({
        el: content.find('#txt-assignee'),
        cls: 'member-select',
        placeholder: '输入成员姓名（缩写）',
        onItemRender: function($itemEl, item) {
          var $span = $('.label', $itemEl);
          var $img = $('<img>').attr('src', item.gavatar).addClass('avatar').insertBefore($span);
          return $itemEl;
        }
      });

      // FIXME: simple-select requireSelect 参数不可配置
      memberSelect.requireSelect = false;

      var projectId;
      if (link.hasClass('todo-assign-due') || link.hasClass('check-item-quicklink')) {
        projectId = link.data('request-members');
      } else {
        projectId = link
                      .closest(resourceType == 'check-item' ? '.check-item-form' : '.todo-form')
                      .data('project-guid');
      }

      var memberId = link.find('.assignee').data('guid');
      if (memberId) {
        memberSelect.input.data('member-guid', memberId);
      }

      if (tower.members[projectId]) {
        tower.updateMemberList(memberSelect, tower.members[projectId]);
      }

      memberSelect.on('select clear', function(e) {
        var popoverEl = memberSelect.input.closest('.simple-popover');
        popoverEl.data('dirty', true);
      });

      memberSelect.on('keydown', function(e) {
        if (e.which === 13 && !memberSelect.input.hasClass('expanded')) { // enter
          e.preventDefault();
          hidePopover();
          return false;
        } else if (e.which === 27) { // esc
          e.preventDefault();
          memberSelect.input.trigger('blur');
          return false;
        } else if (e.which == 9) { // tab
          e.preventDefault();
          var popoverEl = memberSelect.input.closest('.simple-popover');
          if (e.shiftKey) {
            var popover = popoverEl.data('popover');
            if (popover) {
              var labelEl = popover.pointTo;
              var txtTodoContent = labelEl.siblings('.todo-content');
              popover.destroy();
              txtTodoContent.focus();
              tower.selectText(txtTodoContent);
            }
          } else {
            popoverEl.find('.txt-due-date').trigger("mousedown");
          }
          return false;
        }
      });

      var today = tower.now().startOf('day');
      var weekday = today.day();
      var pickerEl = content.find('.due-date-picker');
      var todayStr = today.format('YYYY-MM-DD');

      pickerEl.find('.link-date-shortcut.today')
        .data('date', todayStr)
        .text('今天，' + todayStr);

      var tomorrowStr = today.clone().add(1, 'd').format('YYYY-MM-DD');
      pickerEl.find('.link-date-shortcut.tomorrow')
        .data('date', tomorrowStr)
        .text('明天，' + tomorrowStr);

      var afterTomoStr = today.clone().add(2, 'd').format('YYYY-MM-DD');
      pickerEl.find('.link-date-shortcut.after-tomorrow')
        .data('date', afterTomoStr)
        .text('后天，' + afterTomoStr);

      var tmpDate = null;
      var str = '';

      for (var i = 1; i < 8; i++) {
        tmpDate = today.clone();
        tmpDate.isoWeekday(i + (tmpDate.isoWeekday() > i ? 7 : 0));
        str = tmpDate.format('YYYY-MM-DD');
        pickerEl.find('.link-date-shortcut.' + tmpDate.clone().locale('en').format('dddd').toLowerCase())
          .data('date', str).text(tmpDate.format('dddd') + '，' + str);
      }

      pickerEl.find('.link-cal-shortcut.today')
        .data('date', todayStr);
      pickerEl.find('.link-cal-shortcut.tomorrow')
        .data('date', tomorrowStr);
      pickerEl.find('.link-cal-shortcut.this-friday')
        .attr('title', '本周星期五')
        .data('date', today.clone().day(5).format('YYYY-MM-DD'));
      pickerEl.find('.link-cal-shortcut.next-friday')
        .attr('title', '下周星期五')
        .data('date', today.clone().day(5).add(1, 'w').format('YYYY-MM-DD'));

      content.find('.link-remove-due-date').on('mousedown', function() {
        var link = $(this);
        var txtEl = link.siblings('.txt-due-date');
        var pickerEl = txtEl.nextAll('.due-date-picker');

        txtEl.val('')
          .removeClass('selected')
          .removeData('date')
          .parent()
          .removeClass('selected');

        pickerEl.find('.cal-wrapper')
          .show()
          .siblings('.shortcuts-wrapper')
          .hide();

        txtEl.closest('.simple-popover')
          .data('dirty', true);

        hidePopover();
      });

      var dueDateVal = content.find('.txt-due-date').val();
      var keydownTimer = null;
      content.find('.member-select .select-result').on('focus', function(e) {
        content.find('.due-date-picker').hide();
      });
      content.find('.txt-due-date').on('keydown', function(e) {
        var txtEl = $(this);
        var pickerEl = txtEl.nextAll('.due-date-picker');
        var calendarVisible = !!pickerEl.find('.cal-wrapper:visible').length;

        if (e.which === 9) { // tab
          e.preventDefault();
          var popoverEl = txtEl.closest('.simple-popover');
          if (e.shiftKey) {
            popoverEl.find('.member-select .select-result').focus();
          } else {
            hidePopover();
          }
        } else if (e.which < 41 && e.which > 36) { // arrows
          e.preventDefault();
          if (!txtEl.hasClass('active')) {
            txtEl.addClass('active')
              .nextAll('.due-date-picker').show();
            return;
          }

          var shortcutsEl = pickerEl.find('.shortcuts-wrapper');
          if (e.which === 37 || e.which === 38) {
            var selectedEl = shortcutsEl.find('.link-date-shortcut.selected');
            var prevEl = selectedEl.prevAll('.link-date-shortcut:visible:first');
            if (prevEl.length) {
              selectedEl.removeClass('selected')
              prevEl.addClass('selected');
            }
          } else if (e.which === 39 || e.which === 40) {
            var selectedEl = shortcutsEl.find('.link-date-shortcut.selected');
            var nextEl = selectedEl.nextAll('.link-date-shortcut:visible:first');
            if (nextEl.length) {
              selectedEl.removeClass('selected')
              nextEl.addClass('selected');
            }
          }
        } else if (e.which === 13) { // enter
          e.preventDefault();

          if (txtEl.hasClass('active')) {
            pickerEl.find('.link-date-shortcut.selected').trigger('mousedown');
          }
          hidePopover();
        } else if (e.which === 27) { // esc
          e.preventDefault();
          txtEl.trigger('blur');
        } else if (e.which === 8) { // backspace
          var pickerEl = txtEl.nextAll('.due-date-picker');
          if (txtEl.hasClass('selected')) {
            txtEl.val('')
              .removeClass('selected')
              .removeData('date')
              .parent()
              .removeClass('selected');
          }

          if (!txtEl.hasClass('active')) {
            txtEl.addClass('active');
            pickerEl.show();
          }

          if (!txtEl.val()) {
            pickerEl.find('.cal-wrapper')
              .show()
              .siblings('.shortcuts-wrapper')
              .hide();
          }

          pickerEl.find('.datepicker .datepicker-day a.selected')
            .removeClass('selected');
        }
      }).on('keyup', function(e) {
        if ($.inArray(e.which, [13, 37, 38, 39, 40]) > -1) {
          return false;
        }

        var txtEl = $(this);
        var pickerEl = txtEl.nextAll('.due-date-picker');

        if (!txtEl.hasClass('active')) {
          txtEl.addClass('active')
            .nextAll('.due-date-picker').show();
          //return;
        }

        if (keydownTimer) {
          clearTimeout(keydownTimer);
          keydownTimer = null;
        }

        keydownTimer = setTimeout(function() {
          var val = $.trim(txtEl.val());
          if (val !== dueDateVal) {
            dueDateVal = val;
            txtEl.removeData('date');

            txtEl.closest('.simple-popover').data('dirty', true);
          }

          var re = new RegExp(val, 'i');
          var shortcutWrapper = pickerEl.find('.shortcuts-wrapper');
          var shortcutEls = pickerEl.find('.shortcuts-wrapper .link-date-shortcut');
          var results = shortcutEls.filter(function() {
            var shortcut = $(this).data('shortcut');
            return re.test(shortcut);
          });

          if (results.length && val.length) {
            shortcutWrapper.show();
            shortcutEls.hide().removeClass('selected');
            results.show().eq(0).addClass('selected');
            shortcutWrapper.siblings('.cal-wrapper').hide();
          } else {
            shortcutWrapper.hide();
            shortcutEls.show().removeClass('selected');
            shortcutWrapper.siblings('.cal-wrapper').show();
          }
        }, 0);

      }).on('blur', function(e) {
        var txtEl = $(this).removeClass('active');
        // txtEl.nextAll('.due-date-picker').hide();

        if (!txtEl.data('date') && txtEl.val()) {
          txtEl.addClass('error');
        } else {
          txtEl.removeClass('error');
        }
      }).on('mousedown', function(e) {
        var txtEl = $(this);
        var pickerEl = txtEl.nextAll('.due-date-picker');
        txtEl.addClass('active');
        pickerEl.show();

        txtEl.focus();

        pickerEl.find('.cal-wrapper')
          .show()
          .siblings('.shortcuts-wrapper')
          .hide();

        setTimeout(function() {
          txtEl.select();
        }, 0);
      }).on('dateselected', function(e, date) {
        var txtEl = $(this),
          str = date.readableDate({
            defaultFormat: 'YYYY-MM-DD'
          });

        txtEl.val(str);
      });

      content.find('.link-date-shortcut, .link-cal-shortcut').on('mousedown', function(e) {
        var linkEl = $(this);
        var txtEl = content.find('.txt-due-date');
        var dateStr = linkEl.data('date');
        var date = moment.tz(dateStr, 'YYYY-MM-DD', tower.me.tz).endOf('day');

        txtEl.val(dateStr)
          .data('date', date);

        txtEl.removeClass('active error')
          .addClass('selected')
          .nextAll('.due-date-picker')
          .hide()
          .end()
          .parent()
          .addClass('selected');

        txtEl.closest('.simple-popover')
          .data('dirty', true);

        txtEl.trigger('dateselected', [date]);

        dueDateVal = dateStr;

        if (linkEl.hasClass('link-cal-shortcut')) {
          hidePopover();
        }

        return false;
      });

      link.data("popover").on('popover:beforeDestroy', function(e) {
        var popover = e.target;
        var popoverEl = popover.el;
        var date = popoverEl.find('.txt-due-date').data('date');
        var memberSelect = popoverEl.find('.member-select').data('select');
        var member = memberSelect.selectItem();

        if (memberSelect.items.length) {
          member = member ? member.member : null;
        } else {
          member = popover.pointTo.find('.assignee').data('guid');
        }

        if (link.hasClass('todo-label') || link.hasClass('check-item-form-quicklink')) {
          var form = link.closest('form');
          var hiddenAssignee = form.find('.hidden-assignee');
          var hiddenDueDate = form.find('.hidden-due-date');
          if (member) {
            link.find('.assignee').text(member.nickname)
              .data('guid', member.guid);
            hiddenAssignee.val(member.guid);
          } else {
            link.find('.assignee').text('未指派')
              .removeData('guid');
            hiddenAssignee.val(-1);
          }

          if (date) {
            var dateStr = date.readableDate({
              defaultFormat: 'YYYY-MM-DD'
            });

            link.find('.due').text(dateStr)
              .data('date', date.format());
            hiddenDueDate.val(date.valueOf());
          } else {
            link.find('.due').text('没有截止时间')
              .removeData('date');
            hiddenDueDate.val('');
          }

          if (member || date) {
            link.addClass('selected');
          } else {
            link.removeClass('selected');
          }
        } else if (link.hasClass('todo-assign-due')) {
          if (!popoverEl.data('dirty')) {
            return;
          }

          var todoEl = link.closest(".todo");
          var todoContent = todoEl.find(".todo-content .raw").text();
          var guid = member ? member.guid : -1;
          var dueDate = date ? date.valueOf() : "";

          var data = {
            todo_content: todoContent,
            assignee_guid: guid,
            due_at: dueDate
          };

          simple.loading({
            type: "tiny",
            el: link
          });

          $.ajax({
            url: todoEl.find(".todo-actions .edit").attr("href"),
            data: data,
            success: function(result) {
              var newTodo = $(result.html),
                list = todoEl.closest('.todolist');

              todoEl.replaceWith(newTodo);

              tower.adjustTodo(newTodo);
              tower.initPermission(newTodo);
              $(".workspace .page:last .page-inner").trigger("todoupdate", [todoEl, list, newTodo, list]);
            }
          });
        } else if (link.hasClass('check-item-quicklink')) {
          if (!popoverEl.data('dirty')) {
            return;
          }

          var checkItemEl = link.closest('.check-item');
          var assigneeGuid = member ? member.guid : -1;
          var dueDate = date ? date.valueOf() : "";
          var data = {
            todos_check_item: {
              assignee_guid: assigneeGuid,
              due_at: dueDate
            }
          };

          simple.loading({
            type: "tiny",
            el: link
          });

          $.ajax({
            url: '/check_items/' + checkItemEl.data('guid'),
            method: 'PUT',
            data: data,
            success: function (result) {
              var $updatedCheckItem = $(result.html);

              checkItemEl.replaceWith($updatedCheckItem);
              tower.initCheckItem($updatedCheckItem, { willRemoveLink: $('#page-todo').length ? true : false });
              tower.initPermission($updatedCheckItem);
            }
          });
        } else if (link.hasClass('check-item-quicklink')) {
          if (!popoverEl.data('dirty')) {
            return;
          }

          var checkItemEl = link.closest('.check-item');
          var assigneeGuid = member ? member.guid : -1;
          var dueDate = date ? date.valueOf() : "";
          var data = {
              todos_check_item: {
                  assignee_guid: assigneeGuid,
                  due_at: dueDate
              }
          };

          simple.loading({
              type: "tiny",
              el: link
          });

          $.ajax({
              url: '/check_items/' + checkItemEl.data('id'),
              method: 'PUT',
              data: data,
              success: function (result) {
                var $updatedCheckItem = $(result.html);

                checkItemEl.replaceWith($updatedCheckItem);
                tower.initCheckItem($updatedCheckItem, { willRemoveLink: $('#page-todo').length ? true : false });
                tower.initPermission($updatedCheckItem);
              }
          });
        } else if (link.hasClass('check-item-assign-due')) {
          if (!popoverEl.data('dirty')) {
              return;
          }

          var checkItemEl = link.closest('.check-item');
          var assigneeGuid = member ? member.guid : -1;
          var dueDate = date ? date.valueOf() : "";
          var data = {
              todos_check_item: {
                  assignee_guid: assigneeGuid,
                  due_at: dueDate
              }
          };

          simple.loading({
              type: "tiny",
              el: link
          });

          $.ajax({
              url: checkItemEl.data('url'),
              method: 'PUT',
              data: data
          });
        }
      });

      function hidePopover() {
        var popover = link.data("popover");
        if (popover) popover.destroy();
        setTimeout(function() {
          link.closest('form')
            .find('button:submit')
            .focus();
        }, 0);
      }
    }

    return false;
  }

  function beforeDelTodo(e, xhr, settings) {
    const todo = $(e.target).closest('.todo');
    if (todo.closest('.page-inner').is("#page-todo") && !todo.is('tr-todo-item')) {
      simple.loading({
        type: 'global',
        msg: '正在删除任务...'
      });
    }
  }

  function delTodoSuccess(e, result) {
    const todo = $(e.target).closest('.todo');

    if (todo.closest('.page-inner').is("#page-todo") && !todo.is('tr-todo-item')) {
      simple.loading.destroy();

      var url = todo.closest('.page-inner').data('parent-url');
      if (url) {
        tower.stack.load(url, { replace: true });
      } else {
        tower.stack.load("/projects/" + todo.data("project-guid") + "/", {
          root: true
        });
      }
    } else if (todo.closest('.expanded-todo')) {
      const expandedTodo = todo.closest('.expanded-todo');
      if (expandedTodo.length) {
        expandedTodo.fadeOut(function() {
          var list = todo.closest('.todolist');
          expandedTodo.remove();
          $(".workspace .page:last .page-inner").trigger('todoremove', [todo, list, null, null]);
        });
      } else {
        todo.fadeOut(function() {
          var list = todo.closest('.todolist');
          todo.remove();
          $(".workspace .page:last .page-inner").trigger('todoremove', [todo, list, null, null]);
        });
      }
    }
  }

  var completeRequest;

  function toggleComplete(e) {
    var chb = $('input[name="todo-done"]', e.target),
      simpleCheckbox = chb.data("simple-checkbox"),
      done = chb.is(':checked'),
      todo = chb.closest('.todo'),
      list = todo.closest('.todolist'),
      todoId = todo.data("guid"),
      projectId = todo.data("project-guid"),
      url = "/projects/" + projectId + "/todos/" + todoId + (done ? "/complete/" : "/reopen/");

    if (!chb.length) return;

    simpleCheckbox.disable();

    completeRequest = $.ajax({
      url: url,
      dataType: 'json',
      type: 'post',
      success: function(result) {
        var newTodo = $(result.html),
          checkbox = $('input[type="checkbox"]', newTodo),
          todos = done ? list.find('.todos-completed') : list.find('.todos-uncompleted'),
          runner = $('.runner.on', todo);

        tower.todoSubject.next('update', {
          id: todo.attr('id').split('_')[1],
          html: result.html,
        });

        if (runner.length) {
          todo.one(simple.util.transitionEnd(), function() {
            setTimeout(function() {
              handleTodo();
            }, 500);
          });

          runner.removeClass('on');
        } else {
          handleTodo();
        }

        function handleTodo() {
          if ($('.tr-page[opened]').length) {
            todo.replaceWith(newTodo);

            if (done) {
              $(".tr-page[opened]").trigger('todocomplete', [todo, list, newTodo, list]);
            } else {
              $(".tr-page[opened]").trigger('todoreopen', [todo, list, newTodo, list]);
            }
          } else if ($('#page-todo').length) {
            todo.replaceWith(newTodo);

            if (done) {
              $(".workspace .page:last .page-inner").trigger('todocomplete', [todo, list, newTodo, list]);
            } else {
              $(".workspace .page:last .page-inner").trigger('todoreopen', [todo, list, newTodo, list]);
            }
          } else {
            var list = todo.closest('.todolist');

            if (done) {
              const expandedTodo = todo.closest('.expanded-todo');
              if (expandedTodo.length) {
                expandedTodo.fadeTo(200, 0);
                expandedTodo.slideUp(200, function() {
                  expandedTodo.remove();

                  $(".workspace .page:last .page-inner").trigger('todocomplete', [todo, list, newTodo, list]);
                })
              } else {
                todo.fadeTo(200, 0);
                todo.slideUp(200, function() {
                  todo.remove();
                  newTodo.prependTo(todos);

                  $(".workspace .page:last .page-inner").trigger('todocomplete', [todo, list, newTodo, list]);
                });
              }
            } else {
              todo.fadeOut(function() {
                todo.remove();
                newTodo.appendTo(todos);

                $(".workspace .page:last .page-inner").trigger('todoreopen', [todo, list, newTodo, list]);
              });
            }
          }

          tower.adjustReadableTime(newTodo);
          tower.adjustTodo(newTodo);
          tower.initPermission(newTodo);
        }
      }
    });
  }

  $.extend(tower, {
    sortTodos: function($selector) {
      var $page = $('.workspace .page-inner'),
          $newTodolist,
          $oldTodolist;
      if ($page.is('[data-archived], [data-not-access], [data-deleted]')) {
        return;
      }

      $selector = $selector || $('.todos-uncompleted');

      $selector.sortable({
        handle: '.todo-content',
        connectWith: '.todos-uncompleted:visible',
        scrollSensitivity: 20,
        cursor: 'move',
        distance: 5,
        helper: 'clone',
        items: '.todo',
        placeholder: 'todo-placeholder',
        tolerance: 'pointer',
        start: function(e, ui) {
          $selector.addClass('sorting');
          ui.placeholder.css({
            height: ui.helper.outerHeight(true) - 4
          });
        },
        stop: function(e, ui) {
          var $todo = ui.item;

          $.ajax({
            url: $todo.data('sort-url'),
            data: {
              completed: $todo.hasClass('completed'),
              list_guid: $todo.closest('.todolist').data('guid'),
              prev_todo_guid: $todo.prev('.todo').data('guid'),
              next_todo_guid: $todo.next('.todo').data('guid')
            },
            success: function() {
              $(".workspace .page:last .page-inner").trigger("todoupdate", [$todo, $oldTodolist, $todo, $newTodolist]);
            }
          });

          $selector.removeClass('sorting');
        }
      });

      $('.workspace .page-inner').on('todoreopen todoupdate todocreate', function(e, oldTodo, oldList, newTodo, newList) {
        try {
          newTodo.closest('.ui-sortable').sortable('refresh');
          oldList[0].updateTodoCount();
          newList[0].updateTodoCount();
        } catch (error) {}
      });
    },

    updateMemberList: function(memberSelect, members) {
      if (!memberSelect || memberSelect.setItems()) {
        return;
      }

      var $el = memberSelect.input;
      var visitorLock = false;
      var popover = $el.closest('.simple-popover').data('popover');
      var $lock = popover ? popover.pointTo.closest('[data-visitor-locked]') : null;
      if ($lock && $lock.length > 0) {
        visitorLock = true;
      }

      var items = [];
      var memberId = $el.data('member-guid');
      var selectedItem = null;
      $.each(members, function(i, member) {
        if (visitorLock && member.visitor) {
          return;
        }

        var item = {
          label: member.nickname,
          key: member.nickname_pinyin + ' ' + member.nickname_pinyin_abbr + ' ' + member.nickname,
          member: $.extend({}, member),
          gavatar: member.gavatar
        };

        if (memberId && memberId == member.guid) {
          selectedItem = item;
        }

        if (member.guid === tower.me.guid) {
          item.label += '（我自己）';
          item.key += ' me';
        }

        items.push(item);
      });

      memberSelect.setItems(items);
      memberSelect.selectItem($.inArray(selectedItem, items));
      $el.removeAttr('data-member-guid')
        .removeData('member-guid');
    },

    adjustTodo: function(el) {
      if (!el || $(el).is('.placeholder.todo')) return;
      var $el = $(el)
      var todoEls = $el.is(".todo") ? $el : $(".todo", $el),
        page = $(".workspace .page:last .page-inner");


      if (page.is("[data-archived], [data-not-access], [data-deleted]")) {
        todoEls.find("input:checkbox").attr("disabled", "disabled");
        todoEls.find(".todo-assign-due").addClass("disabled");
      }

      if (page.is("[data-template]") && $el.find('tr-checkbox-field').length) {
        $el.find('tr-checkbox-field').get(0).disabled = true;
      } else {
        var today = tower.now().startOf('day');

        todoEls.find(".todo-assign-due").each(function() {
          var wrap = $(this);
          var dueEl = wrap.find('.due');
          var date = dueEl.data('readable-date');
          date = moment.tz(date, tower.me.tz).startOf('day');

          if (!date.isValid()) return;

          if (date.isBefore(today)) {
            wrap.addClass('delay');
          }
        });

        todoEls.each(function(i, t) {
          var t = $(t),
            assignee = $('.assignee', t),
            runElem = t.find('.run'),
            pauseElem = t.find('.pause');

          if (tower.me && tower.me.guid &&
            t.is('.running') &&
            assignee.data('guid') === tower.me.guid) {

            runElem.hide();
            pauseElem.css('display', 'flex');
          }

          $('input[name="todo-done"]', t).each(function() {
            var checkbox = simple.checkbox({ el: $(this) });

            if ($(this).attr('data-access') !== undefined) {
              checkbox.el.attr('data-access', true);
            } else if ($(this).attr('data-no-access') !== undefined) {
              checkbox.el.attr({
                'data-no-access': true,
                'data-position': $(this).data('position'),
                'data-tooltip': $(this).data('tooltip')
              });
            }
          });
        });
      }
    },
    todoSubject: resourceSubject('todo')
  });

})(jQuery);
